import React, { useState, useContext } from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import { PermissionsContext } from 'contexts/PermissionsContext';
import { BudgetTableContainer } from './BudgetTable';
import { BudgetOverviewContainer } from './BudgetOverview';
import { BudgetPerformanceContainer } from './BudgetPerformance';
import { Wrapper } from './BudgetTracker.styles';
import { CONFIG } from './routes';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getCurrencySymbolFromOptions } from 'Details/utils';

export const BudgetTracker = ({ currencySymbol, currency }) => {
	const [tableData, setTableData] = useState(null);
	const [ignoreCache, setIgnoreCache] = useState(true);

	return (
		<Wrapper>
			<Switch>
				{CONFIG.map(({ name, path }) => {
					return (
						<Route
							key={path}
							path={path}
							render={routerProps => {
								if (name === 'table') {
									return (
										<BudgetTableContainer
											tableData={tableData}
											setTableData={setTableData}
											ignoreCache={ignoreCache}
											setIgnoreCache={setIgnoreCache}
										/>
									);
								}

								if (name === 'performance') {
									return (
										<BudgetPerformanceContainer
											currencySymbol={currencySymbol}
										/>
									);
								}

								return (
									<BudgetOverviewContainer
										currencySymbol={currencySymbol}
										currency={currency}
										{...routerProps}
									/>
								);
							}}
						/>
					);
				})}

				<Redirect to={CONFIG.find(item => !item.disabled).path} />
			</Switch>
		</Wrapper>
	);
};

export default props => {
	const { currency } = useContext(QueryStringContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);

	return (
		<PermissionsContext.Consumer>
			{({ permissions }) => (
				<BudgetTracker
					{...props}
					permissions={permissions || []}
					currencySymbol={currencySymbol}
					currency={currency}
				/>
			)}
		</PermissionsContext.Consumer>
	);
};
